<style>
.TableBorder{
 border: 1px solid black;
}
.Geral {
font-family:Arial;
font-size:8px;
width: 530px;
color:black;
}
.Logo {
width: 80px;
}
.TextBlack {
background:black;
color:white;
}


</style>

<template>
<form
  id="app"
  v-on:submit.prevent="ConsultarRelatorio()"
  method="post"
>
<div>
<b-card-code v-bind:title="RelName">
    <b-row>
      <b-col
        md="6"
        xl="3"
        class="mb-1"
      >
        <b-form-group
          label="Nº PLAQUETA:"
          
        >
          <b-form-input
            id="Plaqueta"
            placeholder=""
            v-model="Plaqueta"
            rows="1"
            required
          />
        </b-form-group>
      </b-col>
    </b-row>

   <b-row>
         <b-col
        md="6"
        xl="12"
        class="mb-1"
      >
      <div class="DivBotaoLadoLado" >
       <b-button
      variant="danger"
      type="button"
      @click="$router.push('../Relatorios')"
    >
      <span>RETORNAR</span>
    </b-button>
      </div>
      <div class="DivBotaoLadoLado" >
    <b-button
      variant="primary"
      type="submit"
    >
      <span>CONSULTAR
      </span>
    </b-button>
      </div>
    </b-col>

    </b-row>
  </b-card-code>

<b-card-code title="" v-show="MostraResultado">
  <b-row>
         <b-col
        md="6"
        xl="12"
        class="mb-1"
      >
      <div class="DivBotaoLadoLado" >
       <b-button
      variant="success"
      type="button"
      @click="GerarPdf()"
    >
      <span>PDF
        <feather-icon
            :icon="'DownloadCloudIcon'"
            size="15"
          />
      </span>
    </b-button>
      </div>
    </b-col>

    </b-row>
    <b-row>
    <div id="element-to-print" v-show="MostraResultado" v-for="Dados in DadosRelatorio" :key="Dados.Plaqueta">

       <div class="Geral">
           <table class="Geral TableBorder">
             <tr >
               <td rowspan="2" ><center>
                 <b-img
                    fluid
                    :src="image"
                    alt=""
                    class="Logo"
                  />
                 </center></td>
               <td rowspan="2" class="TableBorder" >
                 <center> <b>DEVOLUÇÃO DE BEM MOVEL</b></center>
               </td>
               <td rowspan="2" >FL-TI-06<br>Versão: 01<br>Data: 05.06.2018</td>
             </tr>
             <tr>
             </tr>
           </table>
       </div>

      <div class="Geral">
       <br>
         <table class="Geral TableBorder">
           <tr class="TableBorder">
             <td colspan="2" class="TextBlack TableBorder">1. DESCRIÇÃO DO OBJETO</td>
           </tr>
           <tr class="TableBorder">
             <td class="TableBorder">BEM MÓVEL:</td>
             <td class="TableBorder">{{Dados.Plaqueta}}</td>
           </tr>
           <tr class="TableBorder">
             <td class="TableBorder">DESCRIÇÃO:</td>
             <td class="TableBorder">{{Dados.Descricao}}</td>
           </tr>
           <tr class="TableBorder">
             <td colspan="2" class="TableBorder">COMPLEMENTO:{{Dados.ProdObs}}</td>
           </tr>
         </table>
      </div>

      <div class="Geral">
         <br>
         <table class="Geral TableBorder">
           <tr class="TableBorder">
             <td colspan="2" class="TextBlack">2. DESCRIÇÃO DO RESPONSÁVEL:</td>
           </tr>
           <tr class="TableBorder">
             <td colspan="2" class="TableBorder">NOME: {{Dados.Responsavel}}</td>
           </tr>
           <tr class="TableBorder">
             <td style="width:50%" class="TableBorder">CPF: {{Dados.ENTCPFCGC}}</td>
             <td style="width:50%" class="TableBorder">RG: {{Dados.ENTRGIE}}</td>
           </tr>
           <tr class="TableBorder">
             <td colspan="2" class="TableBorder">ENDEREÇO: {{Dados.ENDERECO}}</td>
           </tr>
         </table>
      </div>

      <div class="Geral">
        <br><br><br><br>

        <center>Curitiba-PR, ___________ de _______________________________ de __________.</center>

        <br><br><br><br><br><br><br>

        <center>
        __________________________________________________________________
        <br>
        ASSINATURA DO RESPONSÁVEL QUE ESTÁ DEVOLVENDO</center>

       <br><br><br><br><br><br>

       <center>
       __________________________________________________________________
       <br>
       ASSINATURA DO RESPÓNSÁVEL QUE ESTÁ RECEBENDO
       </center>

      </div>

      <div class="Geral">
      <br><br><br><br><br><br><br>
        <table class="Geral TableBorder">
          <tr class="TableBorder">
            <td style="width:50%;" class="TextBlack TableBorder"><center>Elaborado por:</center></td>
            <td style="width:50%;" class="TextBlack TableBorder"><center>Aprovado por:</center></td>
          </tr>
          <tr class="TableBorder">
            <td style="width:50%;" class="TableBorder"><center>Gabriel Souza – Aprendiz do SGI</center></td>
            <td style="width:50%;" class="TableBorder"><center>Gilmar Machado – Gerente de TI e Sistemas</center></td>
          </tr>
        </table>
      </div>

  </div>
    </b-row>
</b-card-code>
</div>
</form>
</template>

<script>
/* eslint-disable global-require */
import {
  BFormInput, BRow, BCol, BFormGroup, BButton, BImg,
} from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code'
import UtilVUE from '@/customPortal/UtilVUE.vue'
import apiPortalSky from '@/services/apiPortalSky'
import AlertaMsg from '@/customPortal/AlertaMsg.vue'

import Spinner from '@/components/Spinner.vue'

export default {
  components: {
    BCardCode,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BButton,
    BImg,
  },
  data() {
    return {
      RelName: '',
      RelRota: '',
      usuario: '',
      image: require('@/assets/images/logo/LogoVapzaRel.png'),
      MostraResultado: false,
      Plaqueta: '',
      DadosRelatorio: [
        { Plaqueta: '' },
        { Descricao: '' },
        { ProdObs: '' },
        { Responsavel: '' },
        { ENTCPFCGC: '' },
        { ENTRGIE: '' },
        { ENDERECO: '' },
        { OBS2: '' },
      ],
    }
  },
  methods: {
    async MostraReport() {
      let notification = ""
      Spinner.StarLoad()
      const usuario = this.$session.get('usuario')
      
      let ParametroJson = ""
      let URLpost = `/Report/MostraReport?CODUSU=${usuario.codusu}&ROTA=${this.RelRota}`
      await apiPortalSky.post(URLpost, ParametroJson).then(response => {
        if (response.status === 200) {
          if (response.data != null) {
            this.RelName = response.data.descricaoRelatorio
          } else {
            notification = AlertaMsg.FormataMsgFiltroSemRetorno()
            AlertaMsg.FormataMsg(notification)
          }
        }
      }).catch(error => {
        notification = AlertaMsg.FormataMsgAPIError(error)
        AlertaMsg.FormataMsg(notification)
      })

      if(notification === '') {
       Spinner.EndLoad()
      }

    },
    async ConsultarRelatorio() {
      Spinner.StarLoad()
      let notification = ''
      this.MostraResultado = false
      const usuario = this.$session.get('usuario')
      const PATRIMONIO = this.Plaqueta
      const URLpost = `/Report/ExecutaRelTermoDevolucaoBemMovel?CODUSU=${usuario.codusu}&PATRIMONIO=${PATRIMONIO}`
      await apiPortalSky.post(URLpost, PATRIMONIO).then(response => {
        if (response.status === 200) {
          if (response.data.length > 0) {
            this.DadosRelatorio = response.data
            this.MostraResultado = true
          } else {
            notification = AlertaMsg.FormataMsgFiltroSemRetorno()
            AlertaMsg.FormataMsg(notification)
          }
        }
      }).catch(error => {
        notification = AlertaMsg.FormataMsgAPIError(error)
        AlertaMsg.FormataMsg(notification)
      })

      if(notification === '') {
       Spinner.EndLoad()
      }
    },
    GerarPdf() {
      UtilVUE.ExportDoc('PDF','RelTermoDevolBemMovel','element-to-print',null)
    },
  },
  mounted() {
   if (this.$route.name != null) {
      this.RelRota = this.$route.name
      this.MostraReport()
    }
  },
}
</script>
